import React from "react";

const ViolationsContext = React.createContext({
    violations: [],
    setViolations: () => {}
  });

  const VehicleDataContext = React.createContext({
    vehicledetails: [],
    setVehicleData: () => {}
  });
  const CampusIdContext = React.createContext({
    selectedCampusval: "",
    setCampusValue: () => {}
  });
  
   const AllUsersListContext = React.createContext({
    usersData:[],
    setUsersData: () => {}
  });
  export {ViolationsContext,VehicleDataContext,CampusIdContext,AllUsersListContext}